export function Logo({ className = "", light = false, size = 36 }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" className="shrink-0">
        <defs>
          <linearGradient id="sidly-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#0284C7" />
            <stop offset="1" stopColor="#0D9488" />
          </linearGradient>
        </defs>
        <rect width="40" height="40" rx="12" fill="url(#sidly-g)" />
        <path d="M27 13.5c-1.6-1.6-4-2.5-7-2.5-4.5 0-7.5 2.2-7.5 5.3 0 6.5 15 3 15 10 0 3.2-3.2 5.7-8 5.7-3.3 0-6.2-1.2-8-3.2" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" />
        <circle cx="29.5" cy="11" r="2.2" fill="#A7F3D0" />
      </svg>
      <span className={`font-display text-xl font-bold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>SIDLY</span>
    </span>
  );
}
